import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { OkrKeyResult } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadOkrKeyResultUpdateById,
    setOkrKeyResultUpdateEdit,
    setOkrKeyResultUpdateReloadEdit,
    initOkrKeyResultUpdate,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface UpdateEditProps {
    updateId: number
    keyResult: OkrKeyResult
}

const KeyResultUpdateEdit = ({
    updateId = null,
    keyResult,
}: UpdateEditProps) => {
    const update = useSelector((state: StoreType) => state.okrKeyResultUpdate.updateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.okrKeyResultUpdate.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setOkrKeyResultUpdateReloadEdit(false))
        setTimeout(() => {
            dispatch(setOkrKeyResultUpdateReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (updateId === 0) {
            dispatch(setOkrKeyResultUpdateEdit(initOkrKeyResultUpdate))
            reload()
        } else {
            setLoadState(PENDING)
            LoadOkrKeyResultUpdateById(updateId, keyResult.id).then((res) => {
                dispatch(setOkrKeyResultUpdateEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!update) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {update.id ? lang.editKeyResultUpdate : lang.updateKeyResult}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                {
                    !reloadEdit && (
                        <Form
                            update={update}
                            keyResult={keyResult}
                        />
                    )
                }
                {
                    reloadEdit && (
                        <Form
                            update={update}
                            keyResult={keyResult}
                        />
                    )
                }
            </PageContent>
        </Container>
    )
}
export default KeyResultUpdateEdit
